import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { AssessorLayout } from '@layouts/AssessorLayout/AssessorLayout';
import { Container } from '@layouts/Container/Container';
import { Button } from '@acb_devel/design-system';
import { AngleLeftIcon } from '@acb_devel/design-system';
import { ProfileData } from '@components/assessors/organisms/ProfileData/ProfileData';
import { getUser } from '@services/users';
import { RegistrationsCard } from '@components/assessors/organisms/RegistrationsCard/RegistrationsCard';
import { AchievementsCard } from '@components/assessors/organisms/AchievementsCard/AchievementsCard';
import { FeedbackCard } from '@components/assessors/organisms/FeedbackCard/FeedbackCard';
import { getRegistrations } from '@services/registrations';

import type { User } from '@services/users';
import type { Registration } from '@services/registrations';

import styles from './VolunteerDetailsPage.module.scss';

export default function VolunteerDetailsPage() {
  const { userId } = useParams();
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);
  const [registrations, setRegistrations] = useState<Registration[]>([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    getUser(Number(userId))
      .then((data) => {
        setUser(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [userId]);

  useEffect(() => {
    if (!user) {
      return;
    }

    getRegistrations({
      userId: user.id,
      ordering: '-start_event',
    }).then(({ results }) => {
      setRegistrations(results);
    });
  }, [user]);

  return (
    <AssessorLayout>
      <div className={styles.pageContainer}>
        <Container className={styles.container}>
          <div className={styles.header}>
            <Link to="/user/admin">
              <Button
                variant="flat"
                color="primary"
                size="md"
                upperCase={false}
              >
                <AngleLeftIcon /> Volver al listado
              </Button>
            </Link>
          </div>
          <div className={styles.content}>
            <div className={styles.cards}>
              <ProfileData user={user} setUser={setUser} loading={loading} />
              <FeedbackCard user={user} registrations={registrations} />
            </div>
            <div className={styles.cards}>
              <div>
                <RegistrationsCard
                  user={user}
                  registrations={registrations}
                  setRegistrations={setRegistrations}
                />
              </div>
              <div>
                <AchievementsCard user={user} />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </AssessorLayout>
  );
}
